(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uas-account-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uas-header-account')) {
    class UasHeaderAccount extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.uas-account-trigger');
        this.panel = this.querySelector('.uas-account-panel');
        this.closeButton = this.querySelector('.uas-account-close');
        if (!this.panel || !this.trigger) return;
        this.updateViewport = () => {
          const viewport = window.visualViewport;
          const mobile = window.innerWidth <= 600;
          const offset = viewport?.offsetTop || 0;
          const height = viewport?.height || window.innerHeight;
          const width = document.documentElement.clientWidth;
          const rect = this.trigger.getBoundingClientRect();
          const top = mobile ? 66 + offset : Math.max(12 + offset, Math.round(rect.bottom + 12));
          const left = mobile ? 12 : Math.max(12, Math.min(width - Math.min(440, width - 24) - 12, Math.round(rect.right - Math.min(440, width - 24))));
          this.panel.style.setProperty('--uas-account-panel-top', `${top}px`);
          this.panel.style.setProperty('--uas-account-panel-left', `${left}px`);
          this.panel.style.setProperty('--uas-account-panel-max-height', `${Math.max(0, height + offset - top - 20)}px`);
        };
        this.setOpen = (open, restoreFocus = false) => {
          if (open) this.updateViewport();
          this.panel.hidden = !open;
          this.trigger.setAttribute('aria-expanded', String(open));
          this.classList.toggle('is-open', open);
          if (!open && restoreFocus) this.trigger.focus({ preventScroll: true });
        };
        this.onTrigger = () => this.setOpen(this.panel.hidden);
        this.onClose = () => this.setOpen(false, true);
        this.onPointer = (event) => {
          if (!this.panel.hidden && !this.contains(event.target)) this.setOpen(false);
        };
        this.onKey = (event) => {
          if (event.key !== 'Escape' || this.panel.hidden) return;
          event.preventDefault();
          event.stopPropagation();
          this.setOpen(false, true);
        };
        this.onFocusOut = (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.setOpen(false);
        };
        this.trigger.addEventListener('click', this.onTrigger);
        this.closeButton?.addEventListener('click', this.onClose);
        document.addEventListener('pointerdown', this.onPointer);
        this.addEventListener('keydown', this.onKey);
        this.addEventListener('focusout', this.onFocusOut);
        window.addEventListener('resize', this.updateViewport, { passive: true });
        window.visualViewport?.addEventListener('resize', this.updateViewport, { passive: true });
        window.visualViewport?.addEventListener('scroll', this.updateViewport, { passive: true });
      }
      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.onTrigger);
        this.closeButton?.removeEventListener('click', this.onClose);
        document.removeEventListener('pointerdown', this.onPointer);
        this.removeEventListener('keydown', this.onKey);
        this.removeEventListener('focusout', this.onFocusOut);
        window.removeEventListener('resize', this.updateViewport);
        window.visualViewport?.removeEventListener('resize', this.updateViewport);
        window.visualViewport?.removeEventListener('scroll', this.updateViewport);
      }
    }
    customElements.define('uas-header-account', UasHeaderAccount);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uas-purchase-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.UASPurchaseGuard) return;
  const settings = JSON.parse(document.getElementById('uas-purchase-guard-settings').textContent);
  const canPurchase = (variant) => Boolean(variant && typeof variant.price === 'number'
    && Number.isFinite(variant.price) && variant.price > 0 && variant.available === true);
  const cache = new Map();
  const queue = [];
  let activeRequests = 0;
  const drain = () => {
    while (activeRequests < 4 && queue.length) {
      const job = queue.shift();
      activeRequests += 1;
      job.run().then(job.resolve, job.reject).finally(() => {
        activeRequests -= 1;
        drain();
      });
    }
  };
  const requestProduct = (url) => new Promise((resolve, reject) => {
    queue.push({ resolve, reject, run: async () => {
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const response = await fetch(url, {
          headers: { Accept: 'application/json' }, cache: 'no-store', signal: controller.signal
        });
        if (!response.ok) throw new Error(settings.failed);
        return await response.json();
      } finally {
        clearTimeout(timeout);
      }
    } });
    drain();
  });
  const getVariant = async (productUrl, variantId, { fresh = false } = {}) => {
    const url = new URL(productUrl, window.location.origin);
    if (url.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(url.pathname)) {
      throw new Error(settings.failed);
    }
    url.pathname = url.pathname.replace(/\/$/, '') + '.js';
    url.search = '';
    url.hash = '';
    let entry = cache.get(url.href);
    if (fresh || !entry || entry.expires <= Date.now()) {
      entry = { promise: requestProduct(url.href), expires: Date.now() + 30000 };
      cache.delete(url.href);
      cache.set(url.href, entry);
      if (cache.size > 40) cache.delete(cache.keys().next().value);
    }
    let product;
    try {
      product = await entry.promise;
    } catch (error) {
      if (cache.get(url.href) === entry) cache.delete(url.href);
      throw new Error(settings.failed);
    }
    const variant = product.variants?.find((entry) => String(entry.id) === String(variantId));
    if (!variant || typeof variant.price !== 'number' || !Number.isFinite(variant.price)
        || variant.price < 0 || typeof variant.available !== 'boolean') {
      throw new Error(settings.failed);
    }
    return variant;
  };
  window.UASPurchaseGuard = Object.freeze({ canPurchase, getVariant, strings: settings });
  document.dispatchEvent(new Event('uas:purchase-guard:ready'));
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const zeroProduct = form.querySelector('[name="id"][data-variant-price="0"]');
    const cartForm = form.id === 'cart' || form.id === 'cart-drawer-form';
    const zeroCart = cartForm && form.querySelector('.cart-item[data-variant-price="0"]');
    if (!zeroProduct && !zeroCart) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    let message = form.querySelector('.js-form-error, [data-uas-guard-error]');
    if (!message) {
      message = document.createElement('p');
      message.className = 'uas-price-notice';
      message.dataset.uasGuardError = '';
      message.setAttribute('role', 'alert');
      form.prepend(message);
    }
    message.textContent = zeroProduct ? settings.message : settings.cartMessage;
    message.hidden = false;
  }, true);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["uas-square-price-guard"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const guard = window.UASPurchaseGuard;
    if (!guard || window.UASSquarePriceGuard) return;
    window.UASSquarePriceGuard = true;
    const states = new WeakMap();
    const replay = new WeakSet();
    let scheduled = false;
    const buttonSelector = '.Vtl-WishlistProduct__AddToCart';
    const rowSelector = '.Vtl-WishlistProduct';
    const setState = (state, status) => {
      if (!state.button.isConnected || states.get(state.button) !== state || state.status === status) return;
      state.status = status;
      const button = state.button;
      const ready = status === 'ready';
      button.disabled = ready ? state.originalDisabled : true;
      if (ready) {
        button.innerHTML = state.originalHtml;
        if (state.originalAria === null) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', state.originalAria);
      } else {
        button.setAttribute('aria-disabled', 'true');
        button.textContent = status === 'checking' ? guard.strings.checking
          : status === 'sold-out' ? guard.strings.soldOut : guard.strings.unavailable;
      }
      if (state.notice) state.notice.remove();
      state.notice = null;
      if (status === 'zero' || status === 'error') {
        const notice = document.createElement('p');
        notice.className = 'uas-square-price-notice';
        notice.setAttribute('role', 'status');
        const link = document.createElement('a');
        link.className = 'link underline';
        link.href = status === 'zero' ? guard.strings.contactUrl : state.productUrl;
        link.textContent = status === 'zero' ? guard.strings.contact : guard.strings.viewProduct;
        notice.append(document.createTextNode((status === 'zero' ? guard.strings.message : guard.strings.failed) + ' '), link);
        button.insertAdjacentElement('afterend', notice);
        state.notice = notice;
      }
    };
    const classify = (variant) => guard.canPurchase(variant) ? 'ready'
      : Number(variant?.price) === 0 ? 'zero' : 'sold-out';
    const register = (button) => {
      const row = button.closest(rowSelector);
      const link = row?.querySelector('a.Vtl-WishlistProduct__Link');
      if (!link) return null;
      const productUrl = link.href;
      const variantId = new URL(productUrl, window.location.origin).searchParams.get('variant');
      const signature = productUrl + '|' + variantId;
      const previous = states.get(button);
      if (previous?.signature === signature) return previous;
      if (previous?.notice) previous.notice.remove();
      const state = {
        button, productUrl, variantId, signature,
        originalHtml: previous ? previous.originalHtml : button.innerHTML,
        originalDisabled: previous ? previous.originalDisabled : button.disabled,
        originalAria: previous ? previous.originalAria : button.getAttribute('aria-disabled')
      };
      states.set(button, state);
      setState(state, 'checking');
      if (!variantId) {
        setState(state, 'error');
      } else {
        guard.getVariant(productUrl, variantId)
          .then((variant) => setState(state, classify(variant)))
          .catch(() => setState(state, 'error'));
      }
      return state;
    };
    const scan = () => {
      scheduled = false;
      document.querySelectorAll(buttonSelector).forEach(register);
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(scan);
    };
    window.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest(buttonSelector) : null;
      if (!button) return;
      if (replay.has(button)) {
        replay.delete(button);
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
      const state = register(button);
      if (!state || !state.variantId || state.pendingClick) return;
      state.pendingClick = true;
      setState(state, 'checking');
      guard.getVariant(state.productUrl, state.variantId, { fresh: true })
        .then((variant) => {
          if (!button.isConnected || register(button) !== state) return;
          const status = classify(variant);
          setState(state, status);
          if (status === 'ready' && !button.disabled) {
            replay.add(button);
            button.click();
            replay.delete(button);
          }
        })
        .catch(() => setState(state, 'error'))
        .finally(() => { state.pendingClick = false; });
    }, true);
    const observer = new MutationObserver(schedule);
    const observe = () => observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['href'] });
    observe();
    window.addEventListener('pagehide', () => observer.disconnect());
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      observe();
      scan();
    });
    scan();
  };
  if (window.UASPurchaseGuard) start();
  else document.addEventListener('uas:purchase-guard:ready', start, { once: true });
})();
  } catch(e) { console.error(e); }
})();

})();
